import _ from 'lodash'
import classnames from 'classnames'
import { Collapse } from 'antd'
import { shipmentLines_shipment_shipmentLines_items_holes } from '@Orders/OrderDetailsPage/Queries/__generated__/shipmentLines'

import Box from '~/core/Box'
import {
    GroupType,
    TapOptionType,
} from '~/apps/consumer/components/PartViewerModal/types'
import dfmstyles from '~/apps/consumer/components/TapsSidebarDfmUpdate/styles.css'
import styles from '../../styles.css'

export const defaultTitleTapOption = () => 'No threads specified'

export function TapTooDeep({ isGroup = false } = {}) {
    let msg = 'Hole'

    if (isGroup) {
        msg = 'At least 1 hole'
    }
    return (
        <Box className={styles.tapTooDeepText}>
            * {msg} depth exceeds max depth, we will only tap to max depth.
        </Box>
    )
}

export function TapOption(option: TapOptionType | null | undefined) {
    return option?.commonName ? (
        <Box key={option.id} style={{ lineHeight: '25px' }}>
            {`${option.commonName} (Max tap depth: ${option.maxDepth.toFixed(
                2,
            )}mm)`}
        </Box>
    ) : (
        defaultTitleTapOption()
    )
}

export const hasTap = (
    hole: shipmentLines_shipment_shipmentLines_items_holes,
) => Boolean(hole.tapAnnotation)

export const renderHolesHeader = (
    group: GroupType,
    groupedHolesMenus: {
        [key: string]: boolean
    },
    onOpenHoleSubMenu: Function,
) => {
    const { Panel } = Collapse

    return (
        <Collapse
            bordered={false}
            onChange={onOpenHoleSubMenu(group.groupKey)}
            data-test-target="specify-individual-threads"
            className={dfmstyles.threadPanel}
        >
            <Panel
                key={group.groupKey}
                header="Specify threaded holes individually"
            />
        </Collapse>
    )
}

export const renderGroupTapOptions = ({
    holes,
}: {
    holes: shipmentLines_shipment_shipmentLines_items_holes[]
}) => {
    const firstHole = holes[0]
    const firstTap = firstHole.tapAnnotation
    const firstHoleTapId = firstTap?.tapOption?.id

    let mixed = false

    let isHoleDeeperThanTap: boolean | number | undefined

    for (let i = holes.length - 1; i >= 0; i--) {
        const hole = holes[i]
        const { tapAnnotation } = hole
        const tapId = tapAnnotation?.tapOption?.id

        const tapMaxDepth = tapAnnotation?.tapOption?.maxDepth

        isHoleDeeperThanTap =
            isHoleDeeperThanTap ||
            (tapMaxDepth && _.lt(tapMaxDepth, firstHole.depth))

        if (!mixed && firstHoleTapId !== tapId) {
            mixed = true
        }
        if (mixed && isHoleDeeperThanTap) {
            break
        }
    }

    const renderTapOption = () => {
        if (firstTap && firstTap.tapOption) {
            return TapOption(firstTap.tapOption)
        } else {
            return defaultTitleTapOption()
        }
    }

    return (
        <Box direction="col">
            <Box className={classnames(styles.tapMenu)}>
                {mixed ? <Box>Mixed threads</Box> : renderTapOption()}
            </Box>
            {isHoleDeeperThanTap && TapTooDeep({ isGroup: true })}
        </Box>
    )
}
